<div class="g-ui-grid-page__title">
  <app-heading level="h1" [text]="this.findingsTexts.title"></app-heading>
</div>
<app-plugins-system-messages class="g-ui-grid-page__notification"></app-plugins-system-messages>
<app-tabs [tabConfig]="tabConfig" [tabs]="tabs"></app-tabs>
<ng-template #vulnerabilities>
  <app-findings-vulnerabilities></app-findings-vulnerabilities>
</ng-template>
<ng-template #policyViolations>
  <app-findings-policy-violations></app-findings-policy-violations>
</ng-template>

<app-findings-side-panel></app-findings-side-panel>
